import { buildLegacyUrl, getV2 } from './client';

function stripHtml(value = '') {
  return String(value).replace(/<[^>]+>/g, '').trim();
}

function normalizeLegacyPost(post = {}) {
  const media = post._embedded?.['wp:featuredmedia']?.[0];
  const cover =
    media?.media_details?.sizes?.large?.source_url ||
    media?.media_details?.sizes?.medium_large?.source_url ||
    media?.media_details?.sizes?.medium?.source_url ||
    media?.source_url ||
    '';

  return {
    id: post.id,
    slug: post.slug,
    title: stripHtml(post.title?.rendered || 'Untitled'),
    titleHtml: post.title?.rendered || '',
    excerptHtml: post.excerpt?.rendered || '',
    contentHtml: post.content?.rendered || '',
    date: post.date || '',
    coverImage: {
      url: cover,
      alt: media?.alt_text || stripHtml(post.title?.rendered || 'Cover image'),
    },
  };
}

export async function fetchBlogPosts({ perPage = 10 } = {}) {
  try {
    const res = await getV2('/blog.php', {
      params: { per_page: perPage },
    });

    if (res?.status === 'success' && Array.isArray(res?.data?.items)) {
      return res.data.items;
    }
  } catch (error) {
    // Fallback below keeps legacy feed behavior working.
  }

  const q = `/posts?_embed=1&per_page=${perPage}`;
  const response = await fetch(`${buildLegacyUrl('wp_proxy.php')}?q=${encodeURIComponent(q)}`, {
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const payload = await response.json();
  return Array.isArray(payload) ? payload.map(normalizeLegacyPost) : [];
}

export async function fetchBlogPostBySlug(slug) {
  try {
    const snapshot = await fetch(`/content/posts/${encodeURIComponent(slug)}.json`);
    if (snapshot.ok && snapshot.headers.get('content-type')?.includes('application/json')) {
      const post = await snapshot.json();
      if (post?.slug === slug && post.contentHtml) return post;
    }
  } catch (error) {
    // New posts can still be retrieved from WordPress before the next static build.
  }
  try {
    const res = await getV2('/blog.php', {
      params: { slug },
    });

    if (res?.status === 'success' && res?.data) {
      return res.data;
    }
  } catch (error) {
    // Fallback below keeps legacy feed behavior working.
  }

  const q = `/posts?slug=${encodeURIComponent(slug)}&_embed=1`;
  const response = await fetch(`${buildLegacyUrl('wp_proxy.php')}?q=${encodeURIComponent(q)}`, {
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const payload = await response.json();
  if (!Array.isArray(payload) || payload.length === 0) {
    throw new Error('Not found');
  }

  return normalizeLegacyPost(payload[0]);
}
